// args omitted since that's more of a memo scenario
// (this is kind of a memo too, but easier to implement
// and more clearly enforces only executing once)
export function once<T>(fn: () => T): () => T {
  let isExecuted = false;
  let result: T;
  return function () {
    if (!isExecuted) {
      result = fn();
      isExecuted = true;
    }
    return result;
  };
}

export const deferFn = (fn: () => void, delay = 1) => setTimeout(fn, delay);

export function memoize<T extends (...args: Parameters<T>) => ReturnType<T>>(
  fn: T
): T {
  const cache = new Map<string, ReturnType<T>>();

  return function (...args: Parameters<T>): ReturnType<T> {
    const key = JSON.stringify(args);
    if (cache.has(key)) {
      return cache.get(key)!;
    }
    const result = fn(...args);
    cache.set(key, result);
    return result;
  } as T;
}

export function noRepeatCalls<
  T extends (...args: Parameters<T>) => ReturnType<T>,
>(fn: T): T {
  let lastArgs: string;
  let lastResult: ReturnType<T>;

  return function (...args: Parameters<T>): ReturnType<T> {
    const theseArgs = JSON.stringify(args);
    if (theseArgs !== lastArgs) {
      lastArgs = theseArgs;
      lastResult = fn(...args);
    }
    return lastResult;
  } as T;
}
